import urlResource from '../constants/UrlResources';
import getPageUrlInfoFromLocation from '../../lib/location-helper';
// Actions
import fetchTopicTree from './action-topic-list';
import getPopularQuestions from './action-popular-list';
import { fetchQueryParams } from '../../contactUs/actions/action-query-params';
import { clearSuggestions } from '../../contactUs/actions/action-auto-complete';
import { fetchArticleSearchResult } from '../../contactUs/actions/action-article-search';
import getArticleListByTopic from './actions-article-list';
import fetchArticleContent from './action-article-content';
import { getHelpCenterAlerts } from '../../contactUs/actions/index';
import { resetToggleRelated } from '../../contactUs/actions/action-content-toggle';
import { resetBreadcrumb } from '../actions/action-breadcrumb';

const experienceList = {
  personal: 'consumer',
  business: 'merchant',
  premier: 'consumer',
};

function isLocationOutOfSyncWithState(location, state) {
  return location.pathname !== state.location.pathname;
}

function isTopicTreeOutOfSyncWithState(location, state) {
  const pageInfo = getPageUrlInfoFromLocation(location);
  return pageInfo.experience !== state.topicList.experience;
}
function isPopularListOutOfSyncWithState(state) {
  return state.popular.articles && state.popular.articles.length <= 0;
}
function isTopicListOutOfSyncWithState(location, state) {
  const pageInfo = getPageUrlInfoFromLocation(location);
  return (pageInfo.experience !== state.topicList.experience || pageInfo.resource.id !== state.articleList.articleId);
}

function isArticleSyncOutOfWithState(location, state) {
  const pageInfo = getPageUrlInfoFromLocation(location);
  return (pageInfo.experience !== state.article.experience || pageInfo.resource.id !== state.article.id);
}

function isSearchSyncOutOfWithState(location, state) {
  const pageInfo = getPageUrlInfoFromLocation(location);
  return (pageInfo.experience !== state.article.experience || pageInfo.resource.searchTerm !== state.searchResult.searchTerm);
}

function updateRouteState(location) {
  return {
    type: 'LOCATION_CHANGE',
    payload: { location },
  };
}

function routeDidUpdate(location) {
  return (dispatch, getState) => {
    const state = getState();

    if (isLocationOutOfSyncWithState(location, state)) {
      dispatch(updateRouteState(location));
    }

    const pageUrlInfo = getPageUrlInfoFromLocation(location);
    const { experience, resource } = pageUrlInfo;

    if (resource.name === urlResource.HOME && isPopularListOutOfSyncWithState(state)) {
      dispatch(getPopularQuestions(experience));
      dispatch(resetToggleRelated());
    }
    if (resource.name === urlResource.HOME && isTopicTreeOutOfSyncWithState(location, state)) {
      dispatch(fetchTopicTree(experience));
      dispatch(resetToggleRelated());
    }

    if (resource.name === urlResource.TOPIC && isTopicListOutOfSyncWithState(location, state)) {
      dispatch(getArticleListByTopic(resource.id, experience));
      dispatch(resetToggleRelated());
    }

    if (resource.name === urlResource.ARTICLE && isArticleSyncOutOfWithState(location, state)) {
      dispatch(fetchArticleContent(experience, resource.id));
    }

    if (resource.name === urlResource.SEARCH && isSearchSyncOutOfWithState(location, state)) {
      const channel = resource.channelOption || '';
      dispatch(clearSuggestions());
      dispatch(fetchQueryParams({
        q: resource.searchTerm,
        channel,
      }));
      dispatch(fetchArticleSearchResult(resource.searchTerm, experienceList[experience || 'personal'], channel));
    }

    // Check if its Home Page and pass `true` to return all the alerts.
    if (resource.name === urlResource.HOME) {
      dispatch(getHelpCenterAlerts(true));
      dispatch(resetToggleRelated());
      dispatch(resetBreadcrumb());
    } else {
      dispatch(getHelpCenterAlerts(false));
    }
  };
}

export default {
  routeDidUpdate,
};



// WEBPACK FOOTER //
// ./home/actions/actions-router.js